import { useMemo } from 'react';
import { ROUTAGE_BOUTIQUECLUB_INITIAL, indexerRoutagePublic, normaliserSlugPublic } from './boutiqueClubRouting';

const input={width:'100%',padding:8,boxSizing:'border-box',marginTop:4};
const magasinVide=()=>({code:'',slug:'',nom_public:'',actif:true,publie:false,aliases:[]});

export function configRoutageGroupe(configuration={}, groupe={}) {
  const existante=configuration.routage_public || {};
  const code=String(groupe?.code || groupe?.identifiant || existante.code || '').toUpperCase();
  const initial=ROUTAGE_BOUTIQUECLUB_INITIAL.groupes.find((item)=>item.code===code) || {};
  return {
    code,
    slug:existante.slug || initial.slug || code.toLowerCase(),
    nom_public:existante.nom_public || initial.nom_public || groupe?.nom || groupe?.code || '',
    actif:existante.actif !== false,
    publie:!!existante.publie,
    magasins:Array.isArray(existante.magasins) ? existante.magasins : (initial.magasins || []).map((m)=>({...m,nom_source:m.nom_public})),
  };
}

export function validerRoutageGroupe(routage) {
  return indexerRoutagePublic({groupes:[routage]}).erreurs;
}

export default function BoutiqueClubRoutageAdmin({configuration,groupe,onChange}) {
  const routage=useMemo(()=>configRoutageGroupe(configuration,groupe),[configuration,groupe]);
  const erreurs=validerRoutageGroupe(routage);
  const modifier=(cle,valeur)=>onChange({...configuration,routage_public:{...routage,[cle]:valeur}});
  const modifierMagasin=(index,cle,valeur)=>modifier('magasins',routage.magasins.map((m,i)=>i===index?{...m,[cle]:valeur}:m));
  const changerSlug=(cle,valeur,index=null)=>{
    const courant=index==null?routage:routage.magasins[index];
    const suivant=normaliserSlugPublic(valeur);
    if(courant.publie && suivant!==courant.slug && !window.confirm('Ce slug est déjà publié. Le modifier peut casser les QR codes et liens existants. Confirmer la préparation du changement ?')) return;
    if(index==null) modifier(cle,suivant); else modifierMagasin(index,cle,suivant);
  };
  return <fieldset style={{marginTop:16}}><legend>Routage public BoutiqueClub</legend>
    <p>Les slugs publiés sont stables. Un changement réel devra conserver l’ancien slug comme alias/redirection.</p>
    <section style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(210px,1fr))',gap:12}}>
      <label>Nom public du groupe<input style={input} value={routage.nom_public} onChange={(e)=>modifier('nom_public',e.target.value)}/></label>
      <label>Slug groupe<input aria-label="Slug public groupe" style={input} value={routage.slug} onChange={(e)=>changerSlug('slug',e.target.value)}/></label>
      <label><input type="checkbox" checked={routage.actif} onChange={(e)=>modifier('actif',e.target.checked)}/> Groupe visible publiquement</label>
    </section>
    <h4>Magasins publics</h4>
    {routage.magasins.map((magasin,index)=><section key={`${magasin.code}-${index}`} style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))',gap:8,padding:10,border:'1px solid #ddd',marginBottom:8}}>
      <label>Code<input aria-label={`Code magasin ${index+1}`} style={input} value={magasin.code||''} onChange={(e)=>modifierMagasin(index,'code',e.target.value.toUpperCase())}/></label>
      <label>Nom public<input aria-label={`Nom magasin ${index+1}`} style={input} value={magasin.nom_public||''} onChange={(e)=>modifierMagasin(index,'nom_public',e.target.value)}/></label>
      <label>Nom source CRM<input aria-label={`Nom source magasin ${index+1}`} style={input} value={magasin.nom_source||''} onChange={(e)=>modifierMagasin(index,'nom_source',e.target.value)}/></label>
      <label>Slug public<input aria-label={`Slug magasin ${index+1}`} style={input} value={magasin.slug||''} onChange={(e)=>changerSlug('slug',e.target.value,index)}/></label>
      <label><input type="checkbox" checked={magasin.actif!==false} onChange={(e)=>modifierMagasin(index,'actif',e.target.checked)}/> Actif</label>
      <button type="button" onClick={()=>modifier('magasins',routage.magasins.filter((_,i)=>i!==index))}>Retirer</button>
    </section>)}
    <button type="button" onClick={()=>modifier('magasins',[...routage.magasins,magasinVide()])}>+ Ajouter un magasin</button>
    {erreurs.length>0&&<ul role="alert" style={{color:'#a40000'}}>{erreurs.map((e)=><li key={e}>{e}</li>)}</ul>}
  </fieldset>;
}
